import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const TextSizeIncreaseIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="textSizeIncrease" ref={ref} {...props}>
    <path d="M15.44,5V7.49a.75.75,0,0,1-1.5,0V5.7H9.1V18.22h2.3a.75.75,0,0,1,0,1.5H5.3a.75.75,0,0,1,0-1.5H7.6V5.7H2.75V7.49a.75.75,0,0,1-1.5,0V5A.75.75,0,0,1,2,4.2H14.69A.74.74,0,0,1,15.44,5ZM22,11.25H19.75V9a.75.75,0,0,0-1.5,0v2.25H16a.75.75,0,0,0,0,1.5h2.25V15a.75.75,0,0,0,1.5,0V12.75H22a.75.75,0,0,0,0-1.5Z" />
  </Icon>
)) as IconWithRender;

TextSizeIncreaseIcon.displayName = 'TextSizeIncreaseIcon';
TextSizeIncreaseIcon.renderIcon = (props) => (
  <TextSizeIncreaseIcon {...props} />
);
export default TextSizeIncreaseIcon;
